import gql from 'graphql-tag';

const GET_ALL_SOP = gql`
  query {
    getAllSOPs {
      sopId
      name
      description
      emailTemplateList {
        id
        name
        content
        subject
        templateType
      }
      taskTemplateList {
        taskTemplateId
        title
        description
        estimatedTime
        technician {
          userId
          firstName
          lastName
          email
        }
        techGroup {
          groupId
          name
          description
        }
      }
      approverList {
        user {
          userId
        }
        placeHolder
      }
    }
  }
`;

const GET_SOP = gql`
  query getSOP($sopId: ID!) {
    getSOP(sopId: $sopId) {
      sopId
      name
      description
      emailTemplateList {
        id
        name
        content
        subject
        templateType
      }
      taskTemplates {
        taskOrder
        taskTemplate {
          taskTemplateId
          title
          description
          estimatedTime
          technician {
            userId
            firstName
            lastName
            email
          }
          techGroup {
            groupId
            name
            description
          }
        }
      }
      approverList {
        user {
          userId
        }
        placeHolder
      }
    }
  }
`;

export { GET_ALL_SOP, GET_SOP };
